import { render, staticRenderFns } from "./Compact.vue?vue&type=template&id=449140ec&scoped=true&"
import script from "./Compact.vue?vue&type=script&lang=js&"
export * from "./Compact.vue?vue&type=script&lang=js&"
import style0 from "./Compact.vue?vue&type=style&index=0&id=449140ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449140ec",
  null
  
)

export default component.exports